// extracted by mini-css-extract-plugin
export default {"LinkButton":"_LinkButton--Vz9wu","ExternalLink":"_ExternalLink--lzGlB"};